import React, { useState } from 'react';
import { FaGoogle, FaUser} from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import bookingIcon from '../assets/img/brand-booking.256x256.png';
import testimonialsJson from '../assets/translations/en/global.json';

const Testimonials = () => {
  const [t, i18n] = useTranslation("global");
  const testimonialsData = [
    {
      title: 'Dream Apartments',
      personName: ['Kurt W', 'Olga', 'Nikolina S'],
    },
    {
      title: 'DC Executive Homes',
      personName: ['Emanuela', 'Sonja', 'Vili'],
    },
  ];

  const [currentTestimonialIndexA, setCurrentTestimonialIndexA] = useState(0);
  const [currentTestimonialIndexB, setCurrentTestimonialIndexB] = useState(0);

  const handleNextTestimonialA = () => {
    setCurrentTestimonialIndexA((prevIndex) =>
      prevIndex === testimonialsData[0].personName.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  const handlePrevTestimonialA = () => {
    setCurrentTestimonialIndexA((prevIndex) =>
      prevIndex === 0 ? testimonialsData[0].personName.length - 1 : prevIndex - 1
    );
  };
  
  const handleNextTestimonialB = () => {
    setCurrentTestimonialIndexB((prevIndex) =>
      prevIndex === testimonialsData[1].personName.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  const handlePrevTestimonialB = () => {
    setCurrentTestimonialIndexB((prevIndex) =>
      prevIndex === 0 ? testimonialsData[1].personName.length - 1 : prevIndex - 1
    );
  };
  
  const currentTestimonialA = testimonialsData[0];
  const currentTestimonialB = testimonialsData[1];

  const [isHoveredPrev, setIsHoveredPrev] = useState(false);

  return (
    <>
    <div className="flex flex-col items-center">
        <h1 className='font-primary text-[45px]'>{t("navBarT.testimonials")}</h1>
        <div className='flex flex-col lg:flex-row justify-center items-start pt-16 gap-8'>
             {/* Card 1 */}
            <div className="w-45% mx-4 shadow-lg text-center">
            <div className="max-w-md mx-auto">
                <h2 className="text-2xl font-bold mb-4 font-tertiary uppercase tracking-[6px]">{currentTestimonialA.title}</h2>

                 {/* Star ratings */}
                <div className="flex justify-center mt-4">
                {[...Array(5)].map((_, index) => (
                  <span key={index} role="img" aria-label="star">⭐️</span>
                ))}
                </div>

                <div className="flex justify-center my-8">
                    <button onClick={handlePrevTestimonialA}
                    onMouseEnter={() => setIsHoveredPrev(true)}
                    onMouseLeave={() => setIsHoveredPrev(false)}
                    style={{
                      transform: isHoveredPrev ? 'scale(2.1)' : 'scale(1.5)',
                      transition: 'transform 0.3s ease',
                    }}
                    >&lt;</button>
                    <p className='mx-6 tracking-[1px] font-secondary'>{t(`dreamTestimonials.comments.comment${currentTestimonialIndexA + 1}`)}</p>
                    <button onClick={handleNextTestimonialA}
                    onMouseEnter={() => setIsHoveredPrev(true)}
                    onMouseLeave={() => setIsHoveredPrev(false)}
                    style={{
                      transform: isHoveredPrev ? 'scale(2.1)' : 'scale(1.5)',
                      transition: 'transform 0.3s ease',
                    }}
                    >&gt;</button>
                </div>

                <div className="flex items-center justify-center mb-4">
                    <FaUser className="mr-2" size={16} />
                    <p className="text-lg font-semibold font-tertiary tracking-[3px]">{currentTestimonialA.personName[currentTestimonialIndexA]}</p>
                </div>
               
                {/* Google sign and link  */}
                <div className="flex justify-center items-center my-8 font-secondary">
                    <p>More Comments: </p>
                    <a href="https://www.google.com/search?q=dream+apartments+novi+sad&sca_esv=9b41ab9b54a73dba&ei=rO-7Zbv6EcGM9u8P_eWpsAE&hotel_occupancy=&ved=0ahUKEwi7gPvu7oqEAxVBhv0HHf1yChYQ4dUDCBA&uact=5&oq=dream+apartments+novi+sad&gs_lp=Egxnd3Mtd2l6LXNlcnAiGWRyZWFtIGFwYXJ0bWVudHMgbm92aSBzYWQyBhAAGBYYHjICECZIrBdQ1gVYqwdwAXgAkAEAmAHFAaABgwOqAQMyLjG4AQPIAQD4AQHiAwQYASBB4gMGGPIEIKJOiAYB&sclient=gws-wiz-serp#lrd=0x475b102c2999fad9:0xfc56681dc2483cbb,1,,,," target="_blank" rel="noopener noreferrer" className="flex justify-center items-center my-8 font-secondary link-container">
                        <FaGoogle className="ml-2 text-black" style={{ fontSize: '1.5em', lineHeight: 1 }} />
                    </a>
                    <a href='https://www.booking.com/hotel/rs/dream-apartment-1.sr.html#tab-reviews' target="_blank" rel="noopener noreferrer" className="flex justify-center items-center my-8 font-secondary link-container">
                        <img src={bookingIcon} alt="Booking Icon" className="ml-4" style={{ width: '1.5em', height: '1.5em', lineHeight: 1 }} />
                    </a>
                </div>
            </div>
            </div>

      {/* Card 2 */}
      <div className="w-45% mx-4 shadow-lg text-center">
      <div className="max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4 font-tertiary uppercase tracking-[6px]">{currentTestimonialB.title}</h2>

        <div className="flex justify-center mt-4">
         <span role="img" aria-label="star">
          ⭐️
         </span>
         <span role="img" aria-label="star">
           ⭐️
         </span>
         <span role="img" aria-label="star">
           ⭐️
         </span>
         <span role="img" aria-label="star">
           ⭐️
         </span>
         <span role="img" aria-label="star">
           ⭐️
         </span>
        </div>
        
        <div className="flex justify-center my-8">
          <button onClick={handlePrevTestimonialB}
          onMouseEnter={() => setIsHoveredPrev(true)}
          onMouseLeave={() => setIsHoveredPrev(false)}
          style={{
            transform: isHoveredPrev ? 'scale(2.1)' : 'scale(1.5)',
            transition: 'transform 0.3s ease',
          }}
          >&lt;</button>
          <p className='mx-6 tracking-[1px] font-secondary'>{t(`dcExecutiveTestimonials.commentsDC.commentDC${currentTestimonialIndexB + 1}`)}</p>
          <button onClick={handleNextTestimonialB}
          onMouseEnter={() => setIsHoveredPrev(true)}
          onMouseLeave={() => setIsHoveredPrev(false)}
          style={{
            transform: isHoveredPrev ? 'scale(2.1)' : 'scale(1.5)',
            transition: 'transform 0.3s ease',
          }}
          >&gt;</button>
        </div>

        <div className="flex items-center justify-center mb-4">
          <FaUser className="mr-2" size={16} />
          <p className="text-lg font-semibold font-tertiary tracking-[3px]">{currentTestimonialB.personName[currentTestimonialIndexB]}</p>
        </div>
            <div className="flex justify-center items-center my-8 font-secondary">
            <p>More Comments: </p>
            <a href="https://www.google.com/search?sca_esv=59a29399512378e1&q=Dc+executive+homes+novi+sad+reviews&uds=AMwkrPvd9HPvjklT9XyhTA9xedIUl4gKuZhhEX-AIKHe7CUw34vrD4V_BshrJ3pmqUPOiZIu7OBTn_RlQ5MjLQ7b8XRzxcByST1g5I7O0ctNO7jc2LBzOWo_MPCsO_-rb3tmAfoKZu-H&sa=X&sqi=2&ved=2ahUKEwi_8-PHtY-EAxXkgf0HHbzZCTEQxKsJegQICxAB&ictx=0&biw=1536&bih=730&dpr=1.25#lrd=0x475b116d4ee96b31:0xb1deeafd3647fb78,1,,,," target="_blank" rel="noopener noreferrer" className="flex justify-center items-center my-8 font-secondary link-container">
            <FaGoogle className="ml-2 text-black" style={{ fontSize: '1.5em', lineHeight: 1 }} />
            </a>
            <a href='https://www.booking.com/hotel/rs/dc-executive-homes.sr.html#tab-reviews' target="_blank" rel="noopener noreferrer" className="flex justify-center items-center my-8 font-secondary link-container">
                <img src={bookingIcon} alt="Booking Icon" className="ml-4" style={{ width: '1.5em', height: '1.5em', lineHeight: 1 }} />
            </a>
            </div>
        </div>
        </div>
        </div>
     
    </div>
    </>
  );
};

{/* <FaHotel className="ml-2 text-black" style={{ fontSize: '1.5em', lineHeight: 1 }} /> */}
export default Testimonials;
